export default __webpack_public_path__ + "static/media/havan_header.296e1efe.jpg";